import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { GameLogic } from '../../../Logic/GameLogic';
import { GameModel } from '../../../Models/GameModel';

export interface IUILivesControllerOptions {
    onClick(): void;
}

export class UILivesController extends AnimationBaseController {
    $model: GameModel;

    public constructor(
        @Inject private _options: IUILivesControllerOptions,
        @Inject private _gameLogic: GameLogic,
        ) {
        super('UILeavesController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            childControllers: {

            },
            modelWatch: {
                userBalanceLivesCount: () =>  {
                    this.setLivesCounterText();
                    this.setLivesCountdownText()
                },
                userBalanceLivesTime: () => {
                    this.setLivesCounterText();
                    this.setLivesCountdownText()
                },
                userBalanceLivesUnlimitedTime: () => {
                    this.setLivesCounterText();
                    this.setLivesCountdownText()
                }
            },
        }
    }

    protected onInitialize() {
        if (this._options.onClick) {
            this.display.interactive = true;
            this.display.buttonMode = true;
            this.display.on('pointerup', () => {
                this._options.onClick()
            });
        }
        this.setLivesCounterText();
        this.setLivesCountdownText();
    }

    private setLivesCounterText() {
        const txt = this.getDisplayObjectByQuery('txtLivesCounter')[0] as PIXI.Text;
        if (this.$model.userBalanceLivesUnlimitedTimestamp) {
            txt.text = '∞';
            return;
        }
        txt.text = `${this.$model.userBalanceLivesAvailable < 0 ? '*' : this.$model.userBalanceLivesCount}`;
    }

    private setLivesCountdownText() {
        const txt = this.getDisplayObjectByQuery('txtLivesCountdown')[0] as PIXI.Text;
        let timePassed;

        const setTime = (period, time) => {
            timePassed = (period - time) / 1000;
            const hours = Math.floor(timePassed / 60 / 60);
            const minutes = Math.floor((timePassed - hours * 60 * 60) / 60);
            const seconds = Math.floor(timePassed - hours * 60 * 60 - minutes * 60);
            let text = '';
            if (hours) text = text + `${hours < 10 ? '0' + hours : hours}:`;
            text = text + `${minutes < 10 ? '0' + minutes : minutes}`;
            if (!hours) text = text + `:${seconds < 10 ? '0' + seconds : seconds}`;
            txt.text = text;
        }

        if (this.$model.userBalanceLivesUnlimitedTimestamp) {
            setTime(this.$model.userBalanceLivesUnlimitedPeriod, this.$model.userBalanceLivesUnlimitedTime)
            return
        }

        if (this.$model.userBalanceLivesCount >= this.$model.userBalanceLivesAvailable) {
            txt.text = 'MAX';
            return
        }

        setTime(this.$model.userBalanceLivesAddPeriod, this.$model.userBalanceLivesTime)
    }

}
